/* eslint-disable arrow-body-style */
const jobSearchRefineSelectDepartmentStyles = {
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#E8F4FB",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    alignItems: "center",
    display: "flex",
  }),
  option: (provided, state) => ({
    ...provided,
    alignItems: "center",
    backgroundColor: state.isFocused ? "#D2EAF8" : "transparent",
    display: "flex",
  }),
  placeholder: (provided) => ({
    ...provided,
    display: "flex",
    position: "absolute",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "3px 8px",
  }),
  control: (provided) => ({
    ...provided,
    borderColor: "#9daebb",
    cursor: "pointer",
  }),
};

export default jobSearchRefineSelectDepartmentStyles;
